import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const addressPointSlot = css`
  margin: 0 ${spacing(1)} 0 -${spacing(1)};
  display: flex;
  align-items: center;

  ::before {
    /* Убираем лишние divider, которые были реализованы через ::before, из-за их явного указания в BDUI */
    content: none;
  }
`
